import React, { useState } from "react";

import Header from "./header";
import Wrapper from "../../components/Wrapper";
import ComponentsWrapper from "../../components/ComponentsWrapper";

import EntityList from "../../components/List";
import EntityKeypad from "../../components/Keypad";
import {NextLinks} from "../../components/NextLinks/nextLinks";

const EntityPage = (props) => {
    const { entity, config, selectedModule, defaultLocale } = props;
    const [keypadShown, setKeypadShown] = useState(config?.showKeypadFirst || false);
    const keypadToggle = () => {
        setKeypadShown(!keypadShown);
    };
    return selectedModule !== 'material' ?
        <></>
        :
        <Wrapper {...props} title={entity.title /*TODO - discuss/define*/} keypadSwitch={config?.showKeypad || false} keypadShown={keypadShown} onKeypad={keypadToggle}>
            {keypadShown ?
                <EntityKeypad {...{ entity }} {...props} />
                :
                <div>
                    <Header entity={entity} />
                    <ComponentsWrapper {...props} defaultLocale={defaultLocale}/>
                    {entity.strapiChildren.length > 0 && <EntityList {...props} />}
                    <NextLinks relations={entity.Relations} originalLocale={entity.originalLocale} defaultLocale={defaultLocale} onlyRenderIfMatchesPosition={'bottom'}/>
                </div>
            }
        </Wrapper>
};

export default EntityPage;
